import React from 'react'
import { AbsoluteFill } from 'remotion'
import type { TrackType } from '../types'
import { Layer } from './Layer'

const layerWrapperStyle: React.CSSProperties = { overflow: 'hidden' }

/** Every visible track's items, last track at the bottom. */
export const Layers = React.memo(function Layers({
  tracks,
  wrapperRef,
}: {
  tracks: TrackType[]
  wrapperRef?: React.Ref<HTMLDivElement>
}) {
  return (
    <AbsoluteFill style={layerWrapperStyle} ref={wrapperRef}>
      {tracks
        .slice()
        .reverse()
        .map((track) =>
          track.hidden ? null : (
            <React.Fragment key={track.id}>
              {track.items.map((itemId) => (
                <Layer key={itemId} itemId={itemId} trackMuted={track.muted} />
              ))}
            </React.Fragment>
          ),
        )}
    </AbsoluteFill>
  )
})
